var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.7 67.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M33.3 48.8H1.5V5.6h6.7m37.1 0h5.9v31.7M37.4 5.6h3.4m-11.5 0h3.5m-11.9 0h3.7M13 5.6h3.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 23.9,
    r: 2.6,
    fill: "inherit"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7,
    cy: 23.9,
    r: 2.6,
    fill: "inherit"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7,
    cy: 23.9,
    r: 2.6,
    fill: "inherit"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8,
    cy: 23.9,
    r: 2.6,
    fill: "inherit"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 31.9,
    r: 2.6,
    fill: "inherit"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 40.2,
    r: 2.6,
    fill: "inherit"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7,
    cy: 31.9,
    r: 2.6,
    fill: "inherit"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8,
    cy: 31.9,
    r: 2.6,
    fill: "inherit"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7,
    cy: 40.3,
    r: 2.6,
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M17 15.1h19.9M18.8 1.5c1.1 0 2 .9 2 2v3.1c0 1.1-.9 2-2 2h0c-1.1 0-2-.9-2-2V3.5c0-1.1.9-2 2-2m-8.1 0c1.1 0 2 .9 2 2v3.1c0 1.1-.9 2-2 2h0c-1.1 0-2-.9-2-2V3.5c-.1-1.1.8-2 2-2m24.5 0c1.1 0 2 .9 2 2v3.1c0 1.1-.9 2-2 2h0c-1.1 0-2-.9-2-2V3.5c0-1.1.9-2 2-2m8.1 0c1.1 0 2 .9 2 2v3.1c0 1.1-.9 2-2 2h0c-1.1 0-2-.9-2-2V3.5c0-1.1.9-2 2-2M27 1.5c1.1 0 2 .9 2 2v3.1c0 1.1-.9 2-2 2h0c-1.1 0-2-.9-2-2V3.5c0-1.1.9-2 2-2m17.8 29.9c.6.2 1.1.6 1.4 1.1l9.1 11.2c.9 1.1.9 1.1 2.3 1.1 2 .1 4.1.2 6.1.4 1.6.2 3.1 1.1 4.1 2.4.5.7.5 1.6-.1 2.3-1.1 1.4-2.8 2.2-4.5 2.3-2.1.1-4.1.2-6.2.3-.5 0-1 .3-1.3.7-3 3.8-6.1 7.5-9.1 11.3-1.4 1.7-1.5 1.6-3.7 1.4-.2 0-.4-.1-.6-.2-.5-.1-.7-.6-.6-1.1q0 0 0 0c.3-1.1.6-2.2 1-3.2.9-2.8 1.8-5.6 2.7-8.5 0-.1.1-.2.1-.2h-5.2c-.5 0-.9.2-1.2.5-1 1.3-2.1 2.5-3.2 3.8-.2.3-.5.5-.7.8-.6.6-1.5.7-2.2.3-.6-.1-1-.7-.8-1.3v-.1c.2-.8.4-1.5.6-2.3.4-1.7.9-3.4 1.3-5 .1-.3.1-.7 0-1-.6-2.3-1.2-4.6-1.8-7-.4-1.4.1-2 1.7-2.1.5 0 1 .2 1.3.6l2.8 3.3c.4.5.8 1 1.2 1.4q.3.3.6.3h5.6c-.1-.2-.1-.5-.2-.7-1.1-3.4-2.2-6.8-3.3-10.3-.1-.4-.2-.8-.2-1.3 0-.4.3-.8.7-.9.3-.1.7-.1 1-.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirSchedule);
export default __webpack_public_path__ + "static/media/airSchedule.856019ddb2cf95f2095c7353381e1bdf.svg";
export { ForwardRef as ReactComponent };